module.exports = __webpack_public_path__ + "media/images/v3/project-done-72e9a52232a029833615740ba8a3c0e0.png";